import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import withDimensions from '../../hoc/withDimensions';
import { inlineStylesIfRanking } from '../../internal/helpers';
import { RankableTableBodyCell } from '../../styled/rankable/TableCell';
export class RankableTableCell extends React.Component {
  render() {
    const {
      cell,
      head,
      isFixedSize,
      isRanking,
      refWidth,
      innerRef
    } = this.props;
    const {
      content,
      ...restCellProps
    } = cell;
    const {
      shouldTruncate,
      width
    } = head || {};
    const inlineStyles = inlineStylesIfRanking(isRanking, refWidth);
    return /*#__PURE__*/React.createElement(RankableTableBodyCell, _extends({}, restCellProps, {
      isFixedSize: isFixedSize,
      shouldTruncate: shouldTruncate,
      width: width,
      isRanking: isRanking,
      style: inlineStyles,
      onKeyDown: e => e.stopPropagation(),
      innerRef: innerRef
    }), content);
  }

}
export default withDimensions(RankableTableCell);